export const changeTextColor = (status: string) => {
  if (status === "BOOKED" || status === "BOOKING") {
    return "green";
  } else if (status === "COMPLETED") {
    return "#228B22"; // Green for completed
  } else if (status === "CANCELLED") {
    return "red";
  } else if (status === "NOT_STARTED") {
    return "#f05a24"; // Orange for not started
  } else if (status === "ONGOING") {
    return "rgb(255 160 0)"; // Orange for ongoing
  } else if (status === "PAID") {
    return "rgb(11 46 215)"; // Blue for paid
  }

  return "#eab078bd";
};
